
import { defineComponent } from "vue";
import WordScrambler from "@/data/WordScrambler";

export default defineComponent({
  name: "MindGamesHeader",

  data() {
    return {
      mindScrambler: new WordScrambler("MiNd", 5000),
      gamesScrambler: new WordScrambler("GAmES", 5000),
    };
  },

  mounted() {
    this.startScramble();
  },

  methods: {
    startScramble() {
      this.mindScrambler.start();
      this.gamesScrambler.start();
    },
  },
});
